// Tailwind
import { createHead, VueHeadMixin } from '@unhead/vue/client'

import '@repo/styles/cgs'

import { createApp } from './main'

// Firebase etc
// import { VueFire, VueFireAuth, useSSRInitialState } from "vuefire";
// import { firebaseApp } from "./firebase";

const { app, router, pinia } = createApp()

const head = createHead()
app.use(head)
app.mixin(VueHeadMixin)
// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__pinia) {
  pinia.state.value = window.__pinia
}

// app.use(VueFire, {
//   firebaseApp,
//   modules: [
//     VueFireAuth(),
//   ],
// });

router.isReady().then(() => {
  app.mount('#app')
})
